import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {createDsScoutingClient} from "@/api/ds_scouting";
import {getDsContext} from "@/utils/dsContext";
import {DsSection, DsEmpty, DsLink} from "@/components/DsKit";
export default function DsMatchScouting({match}) {
	const context = useSelector(getDsContext);
	const [visions, setVisions] = useState(null),
		[error, setError] = useState(false),
		[retry, setRetry] = useState(0);
	useEffect(() => {
		let active = true;
		setVisions(null);
		setError(false);
		createDsScoutingClient()
			.visions(match.id)
			.then((rows) => {
				if (!Array.isArray(rows)) throw Error("Visioni non disponibili");
				if (active && context === getDsContext()) setVisions(rows);
			})
			.catch(() => {
				if (active && context === getDsContext()) setError(true);
			});
		return () => {
			active = false;
		};
	}, [match.id, context, retry]);
	const targets = match.prospectsObserved || [];
	const targetIds = targets.map((p) => p.playerId).filter(Boolean);
	const targetCount =
		targetIds.length === targets.length
			? new Set(targetIds).size
			: "Da verificare";
	const people = new Set(
		(visions || []).flatMap((v) => (v.rows || []).map((r) => r.playerId)),
	);
	return (
		<DsSection
			title="Scouting"
			action={
				<DsLink to={"/scouting/planning/" + match.id}>
					Dettaglio osservazione
				</DsLink>
			}
		>
			<p>
				Osservatori assegnati:{" "}
				{(match.assignedScouts || []).map((s) => s.name).join(", ") ||
					"Nessuno assegnato"}
			</p>
			{match.scoutNames && (
				<p>Nota osservatori precedente: {match.scoutNames}</p>
			)}
			<p>Obiettivi da osservare: {targetCount}</p>
			{error ? (
				<DsEmpty>
					Visioni non disponibili o accesso non consentito.{" "}
					<button onClick={() => setRetry((n) => n + 1)}>
						Riprova visioni
					</button>
				</DsEmpty>
			) : visions === null ? (
				<p>Caricamento visioni condivise…</p>
			) : (
				<>
					<p>
						Visioni: {visions.length} · Giocatori annotati: {people.size}
					</p>
					{visions.map((v) => (
						<div key={v.id}>
							<b>{v.observer?.name}</b> ·{" "}
							{v.mode === "video" ? "Video" : "Live"}
							{(v.rows || []).map((r) => (
								<p key={r.playerId}>
									<DsLink to={"/ds/giocatore/" + r.playerId}>
										{[r.player?.firstName, r.player?.lastName]
											.filter(Boolean)
											.join(" ") || "Giocatore"}
									</DsLink>{" "}
									· {r.side === "home" ? "Casa" : "Trasferta"} ·{" "}
									{(r.attitudes || []).join(", ")} {r.note}
								</p>
							))}
						</div>
					))}
				</>
			)}
		</DsSection>
	);
}
